import { HorizontalBar } from "./horizontal-bar";
import { HorizontalLegendItem } from "./horizontal-chart-legend-item";

type ChartData = {
	name: string;
	value: number;
};

/** Props Interface */
interface HorizontalChartProps {
	data: Array<ChartData>;
	formatter?: (item: number) => number | string;
}

export function HorizontalChart({ data }: HorizontalChartProps) {
	/** Render */
	return (
		<div className="flex flex-col gap-2">
			<div className="flex flex-row gap-0.5">
				{data.map((_data, index) => {
					return (
						<HorizontalBar
							key={_data.name}
							value={_data.value}
							name={_data.name}
							index={index}
						/>
					);
				})}
			</div>
			<div className="h-stack">
				<div className="gap-8 h-stack">
					{data.map((_data, index) => {
						/** Render */
						return (
							<HorizontalLegendItem
								key={_data.name}
								name={_data.name}
								value={_data.value}
								index={index}
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
}
